<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6">
        <v-card class="mx-auto" flat color="#00000000">
          <v-list-item two-line>
            <v-list-item-avatar tile size="80">
              <v-icon color="primary" size="50px">fas fa-mobile-alt</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1" style="font-weight:500"
                >Números de <br />WhatsApp</v-list-item-title
              >
              <v-list-item-subtitle
                >Crie ou gerencie todos os <br v-if="isMobile" />números de
                WhatsApp.</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" style="float:right" align-self="center">
        <phone-editor
          mode="create"
          :mobile="isMobile"
          v-on:reload-data="loadPhones()"
        ></phone-editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="4" offset-md="8">
                <v-text-field
                  v-model="search"
                  append-icon="fas fa-search"
                  label="Procurar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" v-if="!isMobile">
                <v-data-table
                  :loading="loadingPhones"
                  loading-text="Carregando itens, aguarde..."
                  :search="search"
                  :headers="headers"
                  sort-by="status"
                  sort-desc
                  :items="phones"
                  :items-per-page="-1"
                >
                  <template v-slot:item.active="{ value }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          small
                          :color="value ? 'secondary' : 'error'"
                          >fas fa-mobile-alt</v-icon
                        >
                      </template>
                      <span v-if="value">Número Ativo</span>
                      <span v-else>Número Destivado</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.number="{ item, value }">
                    {{ mtel(value) }}
                  </template>
                  <template v-slot:header.redirections>
                    <div style="width:100%">
                      <div style="width:100%">
                        Redirecionamentos
                      </div>
                      <div style="width:100%; display:flex">
                        <div style="width:45%; text-align: right">
                          Hoje
                        </div>
                        <div style="width:10%">|</div>
                        <div style="width:45%; text-align: left">
                          Mês
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:item.redirections="{ value }">
                    <div style="width:100%; display:flex">
                      <div style="width:45%; text-align: right">
                        {{ value.today }}
                      </div>
                      <div style="width:10%">|</div>
                      <div style="width:45%; text-align: left">
                        {{ value.total }}
                      </div>
                    </div>
                  </template>

                  <template v-slot:item.options="{ item }">
                    <v-btn
                      x-small
                      icon
                      v-on:click="changePhoneStatus(item.id)"
                      :color="item.active ? 'error' : 'secondary'"
                    >
                      <v-icon>fas fa-power-off</v-icon></v-btn
                    >
                    <phone-editor
                      :phone="item.id"
                      mode="edit"
                      :mobile="isMobile"
                      v-on:reload-data="loadPhones()"
                    ></phone-editor>
                    <v-btn
                      x-small
                      icon
                      v-on:click="deleteLink(item.id)"
                      color="error"
                    >
                      <v-icon>far fa-trash-alt</v-icon></v-btn
                    >
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="12" v-else>
                <v-data-table
                  :loading="loadingPhones"
                  loading-text="Carregando itens, aguarde..."
                  :search="search"
                  single-expand
                  show-expand
                  mobile-breakpoint="20"
                  :headers="mobileHeader"
                  :items="phones"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template v-slot:item.name="{ item, value }">
                    <span
                      v-bind:style="{
                        color: item.active ? '#60BA8E' : '#B80C09'
                      }"
                      >{{ value }}</span
                    >
                  </template>
                  <template v-slot:header.redirections>
                    <div style="width:100%">
                      <div style="width:100%">
                        Redirecionamentos
                      </div>
                      <div style="width:100%; display:flex">
                        <div style="width:45%; text-align: right">
                          Hoje
                        </div>
                        <div style="width:10%">|</div>
                        <div style="width:45%; text-align: left">
                          Mês
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:item.redirections="{ value }">
                    <div style="width:100%; display:flex">
                      <div style="width:45%; text-align: right">
                        {{ value.today }}
                      </div>
                      <div style="width:10%">|</div>
                      <div style="width:45%; text-align: left">
                        {{ value.total }}
                      </div>
                    </div>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div style="width:100%; display:flex">
                        <div style="width:60%;">
                          {{ mtel(item.number) }}
                        </div>
                        <div style="width:40%; ">
                          <v-btn
                            x-small
                            icon
                            v-on:click="changePhoneStatus(item.id)"
                            :color="item.active ? 'error' : 'secondary'"
                          >
                            <v-icon>fas fa-power-off</v-icon></v-btn
                          >
                          <phone-editor
                            :phone="item.id"
                            mode="edit"
                            :mobile="isMobile"
                            v-on:reload-data="loadPhones()"
                          ></phone-editor>
                          <v-btn
                            x-small
                            icon
                            v-on:click="deleteLink(item.id)"
                            color="error"
                          >
                            <v-icon>far fa-trash-alt</v-icon></v-btn
                          >
                        </div>
                      </div>
                    </td>
                  </template>
                  <template v-slot:footer>
                    <div style="margin: 15px; float:right">
                      {{ tableFooterText }}
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      top
      right
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="5000"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Axios from "axios";
import Swal from "sweetalert2";
import phoneEditor from "./../components/modules/phoneEditor.vue";
import { mapState } from "vuex";

export default {
  name: "Phones",
  components: { phoneEditor },
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: "success"
    },

    search: "",
    loadingPhones: false,
    headers: [
      {
        text: "STATUS",
        align: "center",
        value: "active",
        sortable: false,
        width: "75px"
      },
      { text: "NOME", value: "name" },
      { text: "NÚMERO", align: "center", sortable: false, value: "number" },
      {
        text: "REDIRECIONAMENTOS",
        sortable: false,
        align: "center",
        value: "redirections",
        width: "250px"
      },
      {
        text: "OPÇÕES",
        sortable: false,
        align: "center",
        width: "150px",
        value: "options"
      }
    ],
    mobileHeader: [
      { text: "NOME", value: "name" },
      {
        text: "REDIRECIONAMENTOS",
        sortable: false,
        align: "center",
        value: "redirections"
      }
    ],
    phones: []
  }),
  computed: {
    tableFooterText: function() {
      const linksCount = this.phones.length;
      let text = `Exibindo todos os ${linksCount} números`;
      if (linksCount < 10) text = `Exibindo todos os 0${linksCount} números`;
      if (linksCount == 0) text = "Não há nenhum número a ser exibido";
      if (linksCount == 1) text = `Exibindo o único número`;
      return text;
    },
    ...mapState({
      isMobile: (state) => state.appStore.isMobile,
      isPortrait: (state) => state.appStore.isPortrait
    })
  },
  methods: {
    mtel: function(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d{2})(\d{4,5})(\d{4})/g, "+$1 ($2) $3-$4");
      return v;
    },
    loadPhones: function() {
      this.loadingPhones = true;
      Axios.get("/api/v1/phones/list")
        .then((response) => {
          const data = response.data;
          if (data.status == "success") {
            this.phones = data.phone_list;
          }
        })
        .catch(() => {
          //
        })
        .finally(() => {
          this.loadingPhones = false;
        });
    },
    changePhoneStatus: function(id) {
      Swal.fire({
        title: "Confirma a alteração do status do Número?",
        showCancelButton: true,
        confirmButtonColor: "#60ba8e",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#B80C09",
        reverseButtons: true,
        icon: "question",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: () => {
          Axios.put("/api/v1/phones/change", { id }).then((response) => {
            const data = response.data;
            if (data.status == "success") {
              this.loadPhones();
              this.snackbar.text = "Status do Número alterado com sucesso!";
              this.snackbar.color = "success";
              this.snackbar.show = true;
            }
          });
        }
      });
    },
    deleteLink: function(id) {
      Swal.fire({
        title: "Confirma a Exclusão do número?",
        text: "Esta ação não poderá ser revertida.",
        showCancelButton: true,
        confirmButtonColor: "#B80C09",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#60ba8e",
        icon: "question",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: () => {
          Axios.put("/api/v1/phones/remove", { id }).then((response) => {
            const data = response.data;
            if (data.status == "success") {
              this.loadPhones();
              this.snackbar.text = "Número removido com sucesso!";
              this.snackbar.color = "success";
              this.snackbar.show = true;
            }
          });
        }
      });
    }
  },
  mounted() {
    this.loadPhones();
  }
};
</script>
<style>
.link-style {
  text-decoration: underline;
  cursor: pointer;
  color: #005377;
  margin-right: 5px;
}
</style>
